module.exports = __webpack_public_path__ + "static/media/travel8.b68bf0dd.jpg";